import * as React from 'react'
import { SVGProps } from 'react'
const SvgBox2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={18} viewBox="0 0 16 18" fill="none" {...props}>
    <path
      d="M7.5 16.713V9.286L1 5.522v7.081c0 .103.026.199.077.289.051.09.128.167.23.23L7.5 16.713Zm1 0 6.192-3.59a.66.66 0 0 0 .231-.231.572.572 0 0 0 .077-.289v-7.08L8.5 9.285v7.427Zm-1.308.973L.808 14.007a1.573 1.573 0 0 1-.594-.59A1.593 1.593 0 0 1 0 12.609v-7.22c0-.289.072-.558.214-.807.143-.249.341-.445.594-.59L7.192.313C7.445.168 7.714.096 8 .096c.286 0 .555.072.808.217l6.384 3.679A1.593 1.593 0 0 1 16 5.39v7.219c0 .29-.072.559-.214.808-.143.248-.341.445-.594.59l-6.384 3.679a1.599 1.599 0 0 1-.808.217c-.286 0-.555-.072-.808-.217Zm4.52-11.412 2.713-1.561-6.117-3.54A.578.578 0 0 0 8 1.075a.578.578 0 0 0-.308.096L5.3 2.547l6.411 3.727ZM8 8.426l2.7-1.567-6.425-3.713-2.7 1.567L8 8.426Z"
      fill="#1C1915"
    />
  </svg>
)
export default SvgBox2
